import React, { Fragment } from 'react';
import { Select } from 'antd';

export default function MonthOptions() {
  return (
    <Fragment>
      <Select.Option value={0}>All</Select.Option>
      <Select.Option value={1}>January</Select.Option>
      <Select.Option value={2}>February</Select.Option>
      <Select.Option value={3}>March</Select.Option>
      <Select.Option value={4}>April</Select.Option>
      <Select.Option value={5}>May</Select.Option>
      <Select.Option value={6}>June</Select.Option>
      <Select.Option value={7}>July</Select.Option>
      <Select.Option value={8}>August</Select.Option>
      <Select.Option value={9}>September</Select.Option>
      <Select.Option value={10}>October</Select.Option>
      <Select.Option value={11}>November</Select.Option>
      <Select.Option value={12}>December</Select.Option>
    </Fragment>
  );
}

export const advancedAnalyticsMonthOptions = [
  {
    value: 'All',
    label: 'All',
  },
  {
    value: 'January',
    label: 'January',
  },
  {
    value: 'February',
    label: 'February',
  },
  {
    value: 'March',
    label: 'March',
  },
  {
    value: 'April',
    label: 'April',
  },
  {
    value: 'May',
    label: 'May',
  },
  {
    value: 'June',
    label: 'June',
  },
  {
    value: 'July',
    label: 'July',
  },
  {
    value: 'August',
    label: 'August',
  },
  {
    value: 'September',
    label: 'September',
  },
  {
    value: 'October',
    label: 'October',
  },
  {
    value: 'November',
    label: 'November',
  },
  {
    value: 'December',
    label: 'December',
  },
];

export const monthOptions = [
  {
    value: 0,
    label: 'All',
  },
  {
    value: 1,
    label: 'January',
  },
  {
    value: 2,
    label: 'February',
  },
  {
    value: 3,
    label: 'March',
  },
  {
    value: 4,
    label: 'April',
  },
  {
    value: 5,
    label: 'May',
  },
  {
    value: 6,
    label: 'June',
  },
  {
    value: 7,
    label: 'July',
  },
  {
    value: 8,
    label: 'August',
  },
  {
    value: 9,
    label: 'September',
  },
  {
    value: 10,
    label: 'October',
  },
  {
    value: 11,
    label: 'November',
  },
  {
    value: 12,
    label: 'December',
  },
];
